/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Extended_Ad_HelpInputs */



/**
* | output |
* | --- |
* | "Extended AD pauses program audio to allow for longer audio descriptions" |
*
* @param {Audio_Description_Export_Extended_Ad_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_extended_ad_help = /** @type {((inputs?: Audio_Description_Export_Extended_Ad_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Extended_Ad_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'AD étendue met en pause l'audio du programme pour permettre des descriptions plus longues")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Funktion „Erweiterte Audiodeskription“ unterbricht die Programmwiedergabe, um längere Audiobeschreibungen zu ermöglichen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La pubblicità estesa mette in pausa l'audio del programma per consentire descrizioni audio più lunghe")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Функция расширенного AD приостанавливает воспроизведение звука программы, чтобы дать возможность добавить более длинные аудиоописания.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El AD extendido pausa el audio del programa para permitir descripciones de audio más largas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加长版音频描述会暂停节目音频，以便进行更长时间的音频描述。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("拡張ADはプログラムの音声を一時停止し、より長い音声説明を可能にします")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विस्तारित विज्ञापन कार्यक्रम के ऑडियो को रोक देता है ताकि लंबे ऑडियो विवरण दिए जा सकें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A função Extended AD pausa o áudio do programa para permitir descrições de áudio mais longas.")
	return /** @type {LocalizedString} */ ("Extended AD pauses program audio to allow for longer audio descriptions")
});